<script setup lang="ts">
import MemberIcon from "./MemberIcon.vue";

const teamMembers = [
  {
    name: "Hopesa C.",
    avatarUrl: "https://avatars.githubusercontent.com/u/93610321?v=4",
    tooltip: "durr",
    description: "CEO",
  },
  {
    name: "NightieTime",
    avatarUrl: "/images/sierra.jpg",
    tooltip: "akhlak",
    description: "Engineering Manager",
  },
  {
    name: "Darrell",
    avatarUrl: "https://avatars.githubusercontent.com/u/138114918?v=4",
    tooltip: "wuf",
    description: "Software Engineer",
  },
  {
    name: "Dimon Arzanel",
    tooltip: "not Zaenal >:(",
    avatarUrl: "https://avatars.githubusercontent.com/u/22173017?v=4",
    description: "Software Engineer",
  },
  {
    name: "NerdyWoffy",
    avatarUrl: "https://avatars.githubusercontent.com/u/50015565?v=4",
    tooltip: "hijau",
    description: "Software Engineer",
  },
  {
    name: "Resi",
    avatarUrl: "/images/resir014_avatar.png",
    tooltip: "Not the tracking number JNE sends you",
    description: "Software Engineer",
  },
  {
    name: "RoastedDuck",
    avatarUrl: "/images/roastedduck_avatar.jpeg",
    tooltip: "P",
    description: "Software Engineer",
  },
  {
    name: "YaaliAnnar",
    avatarUrl: "/images/yaali.jpg",
    tooltip: "This is a tooltip. What are you looking for?",
    description: "Softboar Engineer",
  },
  {
    name: "Xy",
    avatarUrl: "/images/xy_avatar.jpg",
    tooltip: "gm bark",
    description: "Software Engineer",
  },
];
</script>

<template>
  <ul class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
    <li v-for="(member, index) in teamMembers" :key="index">
      <member-icon
        :src="member.avatarUrl"
        :name="member.name"
        :tooltip="member.tooltip"
        :description="member.description"
      />
    </li>
  </ul>
</template>
